module.exports = __webpack_public_path__ + "assets/pdf/terms-of-service.2e596d10.pdf";